<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Title -->
                    <p class="flex-grow-1" v-if="basePage && basePage.titles"><b>{{ $t('pageIntro') }}</b> {{basePage.titles[currentLanguage.key]}}</p>
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <!-- Form -->
                <!-- Titles -->
                <div role="group" class="form-group">
                <label class=""> {{ $t('titleMandatory') }}</label>
                    <CInput class="m-0" type="text" v-model="page.titles[currentLanguage.key]" :invalid-feedback="errorOutput['Titles']" :is-valid="genericValidator(page.titles, attemptedSubmit) && errorValidator('Titles')"></CInput>
                </div>
                <!-- Content -->
                <div role="group" class="form-group">
                    <label class=""> {{ $t('contentsMandatory') }}</label>
                    <vue-editor v-model="page.contents[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(page.contents, attemptedSubmit) == false || errorValidator('Contents') }"></vue-editor>
                    <div v-if="errorOutput['Contents']" class="invalid-feedback">{{errorOutput['Contents']}}</div>
                </div>
                <!-- Action button + submitting -->  
                <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                <CButton v-else type="button" class="btn btn-primary align-self-end" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { mapState } from 'vuex'
import router from '@/router/index';
import { deepClone } from "@/helpers/utils.js";
import { CONSTANTS } from '@/helpers/consts';
import { genericValidator, errorValidator } from "@/helpers/utils.js";
import Page from "@/classes/Page";
import LanguageDropdown from '@/controls/LanguageDropdown.vue'
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import OptionsDropdown from '@/controls/OptionsDropdown.vue'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'
import GalleryPicker from '@/controls/GalleryPicker.vue'
import { VueEditor } from "vue2-editor";
import FormLoading from '@/controls/FormLoading.vue'

  export default {
        components: { LanguageDropdown, ConfirmationPopUp, SingleOptionDropdown, VueEditor, GalleryPicker, OptionsDropdown, FormLoading },
    props:{    
        basePage:
        {
            type: Object,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            page: new Page({},{}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetPage();
    },
    computed:
    {
        ...mapState('pages', ['putPageOutput']),
        ...mapState('pages', ['postPageOutput']),
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = this.alertOutput && Array.isArray(this.alertOutput) ? this.alertOutput : [];

            // Validate multi language fields
            for (const [key, value] of Object.entries(this.page.titles)) { if(!value) { result['Titles'] = this.$i18n.t("validateBothTranslations"); break; }; }
            for (const [key, value] of Object.entries(this.page.contents)) { if(!value) { result['Contents'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
    },
    methods:{
        genericValidator,
        errorValidator,
        resetPage(){
            if(!this.basePage)
            {            
                var titles = {}; var contents = {}; 
                CONSTANTS.supportedLanguages.forEach(language => { titles[language.key] = ""; contents[language.key] = "";  });
                this.page = new Page(titles, contents);
            }
            else
            {
                this.page = deepClone(new Page, this.basePage);    
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;

            // Emit event
            if(this.page.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.page);
            }
        },
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            router.push({name: 'Pages'});
        },
        onProcessTask: function(val)
        {
            if(val != null)
            {
                if(val)
                {
                    this.showConfirmationPopup = true;
                }

                this.submitting = false;
            }
        }
    },
    watch:
    {
        putPageOutput: function(val)
        {
            this.onProcessTask(val);
        },
        postPageOutput: function(val)
        {
            this.onProcessTask(val);
        },
        basePage: function()
        {
            this.resetPage();
        },
        alertOutput: function()
        {
            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

@media only screen and (max-width: 767px) {
    .main-content {
        flex-direction: column;
    }
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}
</style> 